import { getYearsData } from "./auth-service-tools597.js";

function getDecadeRange(decade) {
  const years = getYearsData(decade);
  return [years[0][0], years[3][0]];
}

export { getDecadeRange };